import { apiClient } from './client';

/**
 * Upload a file (e.g. video or image).
 * @param {File} file
 * @returns {{ id, filename, key, url?, ... }}
 */
export async function uploadFile(file) {
  const formData = new FormData();
  formData.append('file', file);
  const { data } = await apiClient.post('/media/upload', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return data;
}

/**
 * A picture or a sound for a question or a word, stored where the platform and the arcade games
 * read them (the public images bucket). Quiz, exam and word saves accept only addresses there.
 * @param {'image'|'audio'} kind
 * @param {File} file
 * @param {(percent: number) => void} [onProgress]
 * @returns {Promise<{ url: string }>}
 */
export async function uploadPublicMedia(kind, file, onProgress) {
  const formData = new FormData();
  formData.append('file', file);
  const { data } = await apiClient.post(`/media/public-${kind}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    // A sound file on a slow line takes longer than the client's 30 s default.
    timeout: 120000,
    onUploadProgress: (e) => {
      if (onProgress && e.total) onProgress(Math.round((e.loaded / e.total) * 100));
    },
  });
  return data;
}
